import apiClient from './client';

export interface LenderProduct {
  name: string;
  urn: string;
  reportDelivery?: Record<string, unknown>;
}

export interface Lender {
  urn: string;
  uuid: string;
  name: string;
  displayName: string;
  status?: 'active' | 'blocked';
  products: (LenderProduct | string)[];
  credentials: LenderCredential[];
  integrations?: Record<string, unknown>;
  branding?: Record<string, unknown>;
  creationDate: string;
  modificationDate: string;
}

export interface LenderCredential {
  name?: string;
  key: string;
  secret?: string;
  value?: string;
}

export interface LenderUser {
  urn: string;
  uuid: string;
  name: string;
  email: string;
  lender?: string;
  privileges?: string[];
  creationDate: string;
  modificationDate: string;
}

export interface CreateLenderRequest {
  name: string;
  displayName: string;
  products?: string[];
  credentials?: LenderCredential[];
  integrations?: Record<string, unknown>;
}

export interface UpdateLenderRequest {
  displayName?: string;
  products?: string[];
  credentials?: LenderCredential[];
  integrations?: Record<string, unknown>;
  [key: string]: unknown;
}

export async function getLenders(): Promise<Lender[]> {
  const response = await apiClient.get('/oms/lenders');
  return response.data;
}

export async function getLender(urn: string): Promise<Lender> {
  const response = await apiClient.get(`/oms/lenders/${urn}`);
  return response.data;
}

export async function createLender(data: CreateLenderRequest): Promise<Lender> {
  const response = await apiClient.post('/oms/lenders', data);
  return response.data;
}

export async function updateLender(urn: string, data: UpdateLenderRequest): Promise<Lender> {
  const response = await apiClient.patch(`/oms/lenders/${urn}`, data);
  return response.data;
}

export async function getLenderProducts(urn: string): Promise<string[]> {
  const response = await apiClient.get(`/oms/lenders/${urn}/products`);
  return response.data;
}

export async function getLenderCredential(urn: string, key: string): Promise<LenderCredential> {
  const response = await apiClient.get(`/oms/lenders/${urn}/credentials/${key}`);
  return response.data;
}

export async function blockLender(urn: string): Promise<void> {
  await apiClient.patch(`/oms/lenders/${urn}/block`);
}

export async function unblockLender(urn: string): Promise<void> {
  await apiClient.patch(`/oms/lenders/${urn}/unblock`);
}

export async function deleteLender(urn: string, confirmUrn: string): Promise<void> {
  await apiClient.delete(`/oms/lenders/${urn}`, { data: { confirmUrn } });
}

export async function getLenderUsers(urn: string): Promise<LenderUser[]> {
  const response = await apiClient.get(`/oms/lenders/${urn}/users`);
  return response.data;
}
